import { KEYBINDING_ACTIONS, getBinding, describeBinding } from './keybindings';
import { k } from '../../localization/t';

// Items that aren't a single remappable action but still belong in the
// shortcut help. Keyed by section so they slot in next to bindings.
const EXTRA_SHORTCUT_ITEMS = {
  [k('Cards')]: [{ keys: ['2×Click'], desc: k('Quick tap / untap') }],
  [k('Piles')]: [{ keys: ['1–9'], desc: k('Draw N from hovered pile') }],
  [k('Dice')]: [{ keys: ['1–9'], desc: k('Set hovered die to N') }],
};

export function buildShortcutSections() {
  const bySection = new Map();
  for (const action of KEYBINDING_ACTIONS) {
    const binding = getBinding(action.id);
    const label = binding ? describeBinding(binding) : null;
    if (!label) continue;
    if (!bySection.has(action.section)) bySection.set(action.section, []);
    const keys = label.includes('+') ? label.split('+') : [label];
    bySection.get(action.section).push({ keys, desc: action.label });
  }
  const sections = [...bySection].map(([label, items]) => ({
    label,
    items: [...items, ...(EXTRA_SHORTCUT_ITEMS[label] ?? [])],
  }));
  for (const [label, items] of Object.entries(EXTRA_SHORTCUT_ITEMS)) {
    if (!bySection.has(label)) sections.push({ label, items });
  }
  return sections;
}
